import type {
  AddOnOutput,
  HighFrequency_AddOn,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

const isAddonOutput = (addon: AddOnOutput | HighFrequency_AddOn | string): boolean =>
  !!(addon as AddOnOutput).name && !!(addon as AddOnOutput).value

export const getNormalizedAddOns = (
  addOns: (AddOnOutput | HighFrequency_AddOn | string)[],
): string[] =>
  addOns.map((addOn) => (isAddonOutput(addOn) ? (addOn as AddOnOutput).name : (addOn as string)))
